import { makeStyles, tokens } from '@fluentui/react-components';

export const useReportingDashboardToolbarStyles = makeStyles({
    filterCard: {
        padding: '12px 24px 12px 24px',
        overflow: 'visible',
        display: 'flex',
        flexDirection: 'row',
        gap: '20px',
        flexWrap: 'wrap',
    },
    column: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'end',

        '&.left': {
            flex: '1 1 auto',
        },
    },
    row: {
        display: 'flex',
        alignItems: 'end',
        gap: '16px',
        flexWrap: 'wrap',
    },
    errorMessage: {
        color: tokens.colorStatusDangerForeground1,
    },
});
